// @flow
import EventListElementWrapper from 'components/event/EventListElementWrapper';
import { connect } from 'react-redux';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/event/EventListElementWrapper';

export default connect(
  (state: StateType): StateProps => ({
    calendarTeamIds: state.settingsState.cat_calendrier_equipes,
  })
)(EventListElementWrapper);
